<script setup>

</script>

<template>
  <Toast />
  <ConfirmDialog />
  <router-view/>
</template>

<style scoped>

</style>
